import { CsiteSupplier } from '@arpada/arp-lib-common-qupro';
import { DatatableMessage } from '../../models/api.models';
export class CsiteData {
    csites: CsiteSupplier[];
    msg: DatatableMessage;
}
